module.exports = __webpack_public_path__ + "img/7passenger_parked.24d42679.svg";